var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "job-preview-content-data-outline",
    {
      staticClass: "mt20 p20 tc",
      attrs: { "update-date": _vm.environment.updateDate },
    },
    [
      _c(
        "job-preview-right-column",
        _vm._g(
          {
            attrs: {
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "comment-class": "environment",
              "comment-highlights": _vm.commentHighlights,
            },
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "data-area pt20" },
        [
          _c(
            "job-preview-content-pie-data",
            _vm._g(
              {
                attrs: {
                  "target-id":
                    "" +
                    _vm.targetIdMap.environment.woman +
                    _vm.targetIdMap.environment.job.suffix,
                  title: "女性社員の割合",
                  "title-class": "mt5",
                  value: _vm.environment.womanRate,
                  "data-test": "woman",
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-preview-content-bar-data",
            _vm._g(
              {
                attrs: {
                  "target-id":
                    "" +
                    _vm.targetIdMap.environment.overtime +
                    _vm.targetIdMap.environment.job.suffix,
                  title: "残業時間（平均）",
                  "title-class": "mt5",
                  value: _vm.environment.overtime,
                  "average-value": _vm.average.environment.overtime,
                  unit: "時間",
                  "data-test": "overtime",
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-preview-content-bar-data",
            _vm._g(
              {
                attrs: {
                  "target-id":
                    "" +
                    _vm.targetIdMap.environment.pto +
                    _vm.targetIdMap.environment.job.suffix,
                  title: "有給取得率",
                  "title-class": "mt5",
                  value: _vm.environment.ptoRate,
                  "average-value": _vm.average.environment.pto,
                  unit: "%",
                  "data-test": "pto",
                },
              },
              _vm.$listeners
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "tc mr15" }, [
        _vm._v("\n    " + _vm._s(_vm.companyName) + "\n  "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "tc mr15" }, [
        _vm._v("\n    の働く環境についてもっと知りたい方はこちら\n  "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "btn-style-02 mt10" }, [
        _c(
          "a",
          {
            style:
              "background: url(" +
              _vm.userCommonImageUrlForPc +
              "/icn_arrow_05.png) no-repeat 8px center;",
            attrs: { target: "_blank" },
          },
          [_c("span", { staticClass: "pl10" }, [_vm._v("データをすべて見る")])]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }